export const getUserInitials = (firstName: string, lastName: string): string =>
  `${firstName?.slice(0, 1).toUpperCase() || ''}${
    lastName?.slice(0, 1).toUpperCase() || ''
  }`;
